import { k } from "./kaplay";
import "./assets/sprites";
import "./assets/fonts";
import "./assets/sounds";
import "./scenes/game";
import "./scenes/menu";

k.setLayers(["backbackground", "background", "game", "foreground", "ui"], "game")

k.go("menu");
